import { 
  AlertCircle,
  Star,
  Coffee,
  Clock,
  Pencil
} from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../components/ui/tooltip';

// Single schedule slot component for vertical view
export function ScheduleSlot({ 
  slot, 
  colIndex, 
  colWidth, 
  member, 
  slotIndex, 
  workHours, 
  isManager, 
  resizingSlot,
  handleSlotClick,
  handleDragStart,
  handleResizeStart,
  calculateNetHours,
  t 
}) {
  const startHour = parseInt(slot.start_time?.split(':')[0] || '0');
  const startMin = parseInt(slot.start_time?.split(':')[1] || '0');
  const endHour = parseInt(slot.end_time?.split(':')[0] || '0');
  const endMin = parseInt(slot.end_time?.split(':')[1] || '0');
  
  const startOffset = (startHour - workHours.start) * 48 + (startMin / 60) * 48;
  const endOffset = (endHour - workHours.start) * 48 + (endMin / 60) * 48;
  const height = Math.max(endOffset - startOffset, 24);
  
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={`schedule-slot absolute ${slot.has_pending_correction ? 'ring-2 ring-amber-500' : ''} ${slot.was_modified ? 'ring-2 ring-blue-400' : ''} ${isManager ? 'cursor-move' : 'cursor-default'} group`}
          style={{
            top: `${startOffset + 4}px`,
            height: `${height - 8}px`,
            left: `calc(${colIndex * colWidth}% + 4px)`,
            width: `calc(${colWidth - 2}% - 8px)`,
            backgroundColor: member?.color || '#3B82F6',
            zIndex: 10 + slotIndex
          }}
          onClick={(e) => isManager && handleSlotClick(e, slot)}
          draggable={isManager && !resizingSlot}
          onDragStart={(e) => handleDragStart(e, slot)}
        >
          {isManager && (
            <div
              className="absolute top-0 left-0 right-0 h-2 cursor-n-resize opacity-0 group-hover:opacity-100 bg-black/20 rounded-t-sm transition-opacity"
              onMouseDown={(e) => handleResizeStart(e, slot, 'top')}
            />
          )}
          
          <div className="font-medium truncate text-[11px]">{slot.user_name?.split(' ')[0]}</div>
          <div className="mono text-[9px] opacity-80">
            {slot.start_time}-{slot.end_time}
            {slot.break_minutes > 0 && <span className="ml-1">(-{slot.break_minutes}m)</span>}
          </div>
          
          <div className="absolute top-1 right-1 flex gap-0.5">
            {slot.was_modified && <Pencil className="h-3 w-3 text-blue-200" title={t?.('scheduleModified') || 'Modifié'} />}
            {slot.has_pending_correction && <AlertCircle className="h-3 w-3" />}
            {slot.comment && <Star className="h-3 w-3 comment-star-yellow" title={slot.comment} />}
            {slot.break_minutes > 0 && <Coffee className="h-2.5 w-2.5" />}
          </div>
          
          {isManager && (
            <div
              className="absolute bottom-0 left-0 right-0 h-2 cursor-s-resize opacity-0 group-hover:opacity-100 bg-black/20 rounded-b-sm transition-opacity"
              onMouseDown={(e) => handleResizeStart(e, slot, 'bottom')}
            />
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent side="right">
        <div className="text-xs space-y-1">
          <p className="font-medium">{slot.user_name}</p>
          <p><Clock className="h-3 w-3 inline mr-1" />{slot.start_time} - {slot.end_time}</p>
          {slot.break_minutes > 0 && (
            <p><Coffee className="h-3 w-3 inline mr-1" />{t('break')}: {slot.break_minutes} min</p>
          )}
          <p className="text-muted-foreground">{t('netHours')}: {calculateNetHours(slot)}h</p>
          {slot.comment && (
            <p className="border-t pt-1 mt-1"><Star className="h-3 w-3 inline mr-1 text-yellow-400" />{slot.comment}</p>
          )}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
